import { dialog } from "nq-component";
import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";
import { upsertUseCase } from "../../../../usecases/object";
import { SubmitImg } from "../../../../components/common/Converter";

class PerformanceFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  // showSuccess() {
  //   console.warn("SDFSDf");
  //   return this.showSuccess("WWWWWWWWWW");
  // }

  // async save() {
  //   const collection = this.view.getCollectionName();
  //   if (this.object.id) {
  //     this.change.id = this.object.id;
  //   } else {
  //     this.change.acl = this.view.getAcl();
  //   }
  //   try {
  //     const region = this.view.getStateRegion();
  //     // console.warn("OFFICE: ", office);
  //     if (region === undefined) {
  //       throw new Error("Select Region");
  //     }
  //     this.change.region = region;
  //     this.change.status = "active";
  //     // this.showSuccess();
  //     // console.warn("DD: ", this.change);
  //     await this.upsertUseCase.execute(collection, this.change);
  //     this.change = {};
  //   } catch (error) {
  //     throw error; // rethrow the error to be caught by the caller
  //   }
  // }
  async submitData(stats) {
    const { object, modifyFiles } = this.view.state;
    const ArrayFile = modifyFiles ? await SubmitImg(modifyFiles) : [];
    object.stats = stats;
    object.modifyFiles = ArrayFile;
    try {
      if (stats === "Rejected") {
        dialog.close();
      }
      await upsertUseCase().execute(object.type.toLowerCase(), object);
      await upsertUseCase().execute("performance", object);
      this.showSuccess("Success!");
    } catch (e) {
      console.error(e);
    }
  }
}

export default PerformanceFormPresenter;
